<template>
  <div class="main-content">
    <!-- BradCrumb header Start-->
    <section class="inner-header-bg">
      <div class="container">
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
          <div class="container">
            <div class="row">
              <div
                class="col-md-12 justify-content-center align-self-center pb-2"
              >
                <div class="breadcrumb-content">
                  <div class="title-section">
                    <h1 class="title text-center text-white">About Us</h1>
                  </div>
                  <div class="breadcrumb-nav">
                    <ul class="breadcrumb-link text-center list-unstyled mb-0">
                      <li class="text-white">
                        <i class="mdi mdi-home theme-light-color pr-2"></i>
                        <a href="index.html">Home</a>
                      </li>
                      <li class="theme-light-color active">About Us</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb End -->
      </div>
    </section>
    <!-- BradCrumb header End -->
    <!-- About-bottom section Start-->
    <section class="section services-inner">
      <center>
        <v-card>
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-title>
            <v-spacer />
            <div class="text-center">
              <h2 class="headline pink--text text--accent-2">Our Mission</h2>
            </div>
            <v-spacer />
          </v-card-title>
          <v-img
            :src="require('../assets/images/Mission.png')"
            width="50%"
            class="img-fluid"
          ></v-img>
        </v-card>
      </center>
      <!-- <div class="container">
			<div class="section-title text-left z-index9">
                    <h2 style="text-align:center;">Our Mission </h2>
						<p style="text-align:center;">
							MoveAmerica’s mission is to cultivate an environment of innovative technology sources from across the nation to advance novel solutions to national security challenges.
						</p>
            </div>
		  </div> -->
    </section>
    <section class="section parallax-bg" id="services">
      <div class="container">
        <div class="section-title text-center z-index9">
          <h2 class="text-white">Our Strengths</h2>
        </div>
        <div class="service-boxes-area">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
              <div
                class="single-service-box mt-30 p-4 bg-white wow fadeIn"
                data-wow-delay="0.2s"
                data-wow-duration="1s"
                style="height:380px"
              >
                <div class="icon">
                  <img src="../assets/images/icons/robust.svg" alt="" />
                </div>

                <h3>Robust Team</h3>
                <p>
                  Our deep pool of expertise in areas relevant to national
                  security, paired with advanced experience in both integrating
                  and rapidly fielding innovative solutions among a diverse set
                  of systems, allows us to create a robust and successful
                  pipeline which ensures mission success.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
              <div
                class="single-service-box mt-30 p-4 bg-white wow fadeIn"
                data-wow-delay="0.4s"
                data-wow-duration="1s"
                style="height:380px"
              >
                <div class="icon">
                  <img src="../assets/images/icons/agility.svg" alt="" />
                </div>
                <h3>Agility</h3>
                <p>
                  Our expansive experience allows MoveAmerica to quickly adapt
                  to unforeseen and unexpected challenges and opportunities.
                </p>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
              <div
                class="single-service-box mt-30 p-4 bg-white wow fadeIn"
                data-wow-delay="0.6s"
                data-wow-duration="1s"
                style="height:380px"
              >
                <div class="icon">
                  <img src="../assets/images/icons/structure.svg" alt="" />
                </div>
                <h3>Structure</h3>
                <p>
                  Flat structure to promote responsiveness and maintain a
                  network of innovators to tackle the nation’s most challenging
                  threats.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About-bottom section End-->
    <!-- Start Testimonial Area -->
    <section
      class="section pt-0 swiper-container testimonial-section"
      id="testimonial"
    >
      <div class="testimonial-header-area">
        <div class="container">
          <div class="text-center section-title">
            <h2></h2>
          </div>
        </div>
      </div>
      <div class="testimonial-content-area wow fadeIn" data-wow-duration="1s">
        <div class="container">
          <div class="row">
            <div class="col-12 mx-auto">
              <!-- <div class="client-swiper-slider mt-4"> -->
              <div class="client-container">
                <!-- <div class="swiper-wrapper "> -->
                <div class="testimonial-item">
                  <!-- <h6 class="client-title font-20">MoveAmerica Culture</h6>
                  <figure class="client-thumb">
                    <img
                      src="assets/images/testi/Culture.png"
                      class="img-fluid rounded-circle"
                      alt="Equity"
                    />
                  </figure> -->
                  <figure>
                    <img
                      src="assets/images/Culture-new.png"
                      class="img-fluid"
                    />
                  </figure>
                  <!-- <p style="text-align:left;">
													MoveAmerica is ideally positioned to develop solutions for emerging technical challenges impacting national interests. Due to a rapidly changing technology landscape, it is important to organize around national security challenges, generate economic value, provide national security, and sustain competitiveness. These are the drivers that MoveAmerica. 
												</p>
												<p style="text-align:left;">
													<ul>
														<li>MoveAmerica has a unique understanding of how to work with stakeholders at every level and the expertise to advocate for region-specific technological and economic development. We work comfortably across multiple scales of businesses – from small-, medium-, and large-sized enterprises to professional societies, educational institutions such as K-12, community colleges, four-year colleges/research universities, and local, state, and federal government. </li>
														<li>MoveAmerica is structured to optimize development activities across networks, so that expertise and tools can be applied in meaningful ways.</li>
														<li>By partnering with government, industry, and academia, MoveAmerica establishes relationships to not only employ but deploy leading experts in science and technology to provide industry leaders and policymakers with sound guidance, proficient expertise, and practical solutions. MoveAmerica is a trusted, impartial companion assisting throughout the process to identify and build what America needs in order to solve the critical challenges facing the nation’s industrial base and supply chains.</li>
													</ul>
												</p> -->
                </div>
                <!-- Add Pagination -->
                <!-- <div class="swiper-pagination"></div> -->
                <!-- </div> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Testimonial Area -->
    <!-- Funfacts Area Start -->
    <!-- <section class="section fun-facts bg-light">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-6">
                        <div class="d-flex align-items-center facts-item">
                            <div class="icon border-right">
                                <span class="theme-light-color mdi mdi-cube-outline"></span>
                            </div>
                            <div class="funfacts-items">
                                <div>
                                    <span id="number1" class="funfact-number">69</span>
                                    <span class="plus-icon">+</span>
                                </div>
                                <p class="name">Projects</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-6">
                        <div class="d-flex align-items-center facts-item">
                            <div class="icon border-right">
                                <span class="theme-light-color mdi mdi-trophy-outline"></span>
                            </div>
                            <div class="funfacts-items">
                                <div>
                                    <span id="number2" class="funfact-number">45</span>
                                    <span class="plus-icon">+</span>
                                </div>
                                <p class="name">Members</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-6">
                        <div class="d-flex align-items-center facts-item">
                            <div class="icon border-right">
                                <span class="theme-light-color mdi mdi-account-group-outline"></span>
                            </div>
                            <div class="funfacts-items">
                                <div>
                                    <span id="number3" class="funfact-number">212</span>
                                    <span class="plus-icon">+</span>
                                </div>
                                <p class="name">Small businesses</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-6">
                        <div class="d-flex align-items-center facts-item">
                            <div class="icon border-right">
                                <span class="theme-light-color mdi mdi-trending-up"></span>
                            </div>
                            <div class="funfacts-items">
                                <div>
                                    <span id="number4" class="funfact-number">64M</span>
                                    <span class="plus-icon">+</span>
                                </div>
                                <p class="name">Funding</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    <!-- Funfacts Area End -->
    <!-- Start Faq's Area -->
    <!-- <section class="section">
            <div class="container">
                <div class="text-center section-title">
                    <h2>Frequently Ask Questions</h2>
                </div>
                <div class="row mt-4">
                    <div class="col-md-6">
                        <div id="accordion" class="accordion accordion-faq wow fadeInUp" data-wow-duration="1s">
                            <div class="card bg-white">
                                <a class="card-header text-dark bg-white py-4 collapsed" data-toggle="collapse" href="#collapseOne">
                                    <span class="card-title">
                                        <strong> How do I join MoveAmerica? </strong>
                                    </span>
                                </a>
                                <div id="collapseOne" class="card-body collapse" data-parent="#accordion">
                                    <p class="m-0">
										All companies that have capabilities relevant to national security, have demonstrated competence in the services/products they offer, and are willing to adhere to the consortium membership  agreement are encouraged to apply. The Consortium will evaluate each applicant to ensure the three criteria are met.​​                                    </p>
                                </div>
                            </div>
                            <div class="card bg-white">
                                <a class="card-header text-dark bg-white py-4 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                                    <span class="card-title">
                                        <strong> Are membership dues required to join MoveAmerica?  </strong>
                                    </span>
                                </a>
                                <div id="collapseTwo" class="card-body collapse" data-parent="#accordion">
                                    <p class="m-0">
										 No. Membership dues are not required to join. Membership fees are collected for services to members as specified in the membership agreement.
                                    </p>
                                </div>
                            </div>
                            <div class="card bg-white">
                                <a class="card-header text-dark bg-white py-4 collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                                    <span class="card-title">
                                        <strong> What services are offered to Members? </strong>
                                    </span>
                                </a>
                                <div id="collapseThree" class="card-body collapse pt-0" data-parent="#accordion">
                                    <p class="m-0">
										 Services provided to Consortium Members consists of 1) access to opportunities, 2) mentoring with a focus toward domain familiarization, in areas such as export control, preparing a proper response to RFI and RFPs, and 3) specific training in cybersecurity compliance. 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div id="accordion1" class="accordion accordion-faq wow fadeInUp" data-wow-duration="1s">
                            <div class="card bg-white">
                                <a class="card-header text-dark bg-white py-4 collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapseFour">
                                    <span class="card-title">
                                        <strong> How are topics selected for a potential project? </strong>
                                    </span>
                                </a>
                                <div id="collapseFour" class="card-body collapse" data-parent="#accordion1">
                                    <p class="m-0">
										 For topics, the national security community consider significant will be reviewed by a Technical Advisory Board for potential responses to acknowledged priority needs. In addition, members will use the results of technology scanning to identify relevant advances in emerging technologies to evolve concepts that have the potential to improve national security responses to acknowledged or emerging threats and nominate topics for national security community consideration and funding.  
									<br> <br>	 
										 Upon approval, plans will be devised for the solicitation process.  
									</p>
                                </div>
                            </div>
                            <div class="card bg-white">
                                <a class="card-header text-dark bg-white py-4 collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapseFive">
                                    <span class="card-title">
                                        <strong>  Can more than one Consortium Member be awarded on a project? </strong>
                                    </span>
                                </a>
                                <div id="collapseFive" class="card-body collapse" data-parent="#accordion1">
                                    <p class="m-0">
										Yes. There may be instances where one Consortium Member has capabilities in a particular area of project and does not meet requirements to fulfill project in its entirety.  When this occurs, Consortium Member is encouraged to team with another to member to propose a comprehensive response. 
                                    </p>
                                </div>
                            </div>
                            <div class="card bg-white">
                                <a class="card-header text-dark bg-white py-4 collapsed" data-toggle="collapse" data-parent="#accordion1" href="#collapseSix">
                                    <span class="card-title">
                                        <strong> Are Consortium Members required to be a current defense contractor? </strong>
                                    </span>
                                </a>
                                <div id="collapseSix" class="card-body collapse" data-parent="#accordion1">
                                    <p class="m-0">
										 No. Consortium Members will consist of traditional and non-traditional suppliers, academia, and research centers. Upon award a member can be considered a member of the defense industrial base.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
    <!-- End Faq's Area -->
  </div>
</template>
<script>
//WOW JS
import { WOW } from "wowjs";
// import Swiper styles
import "../assets/css/swiper.min.css";
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from "swiper";
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
export default {
  name: "about",
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initWowAnimation();
      this.initBackgroundImage();
      this.initFooterHeight();
      this.initCounter();
      this.initTestimonialSlider();
    },
    /*----WOW ANIMATION-----*/
    initWowAnimation() {
      var length = $(".wow").length;
      if (length >= 1) {
        const wow = new WOW({
          boxClass: "wow",
          animateClass: "animated",
          offset: 0,
        });
        wow.init();
      }
    },
    /*----BACKGROUND IMAGE-----*/
    initBackgroundImage() {
      $(".bg-image").css("background", function() {
        var bg =
          "url(" + $(this).data("image-src") + ") no-repeat center center";
        return bg;
      });
    },
    initFooterHeight() {
      var footerHeight = $("footer").outerHeight();
      $(".main-content").css("margin-bottom", footerHeight);
    },
    /*----TESTIMONIAL SLIDER-----*/
    initTestimonialSlider() {
      if ($(".swiper-container").length > 0) {
        var swiper = new Swiper(".client-container", {
          slidesPerView: 1,
          draggable: true,
          spaceBetween: 10,
          // init: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          },
        });
      }
    },
    /*----COUNTER-----*/
    initCounter() {
      $.fn.jQuerySimpleCounter = function(options) {
        var settings = $.extend(
          {
            start: 0,
            end: 100,
            easing: "swing",
            duration: 400,
            complete: "",
          },
          options
        );

        var thisElement = $(this);

        $({ count: settings.start }).animate(
          { count: settings.end },
          {
            duration: settings.duration,
            easing: settings.easing,
            step: function() {
              var mathCount = Math.ceil(this.count);
              thisElement.text(mathCount);
            },
            complete: settings.complete,
          }
        );
      };

      $("#number1").jQuerySimpleCounter({ end: 69, duration: 3000 });
      $("#number2").jQuerySimpleCounter({ end: 45, duration: 3000 });
      $("#number3").jQuerySimpleCounter({ end: 212, duration: 2000 });
      $("#number4").jQuerySimpleCounter({ end: 64, duration: 3000 });
    },
  },
};
</script>
